import React, { useEffect, useState } from 'react';
import './rate.css';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import Nav from '../components/layout/nav';

const Rate = () => {
    const navigate = useNavigate();

    const [rating, setRating] = useState(0);
    const [text, setText] = useState('');
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchReviews();
    }, []);

    const fetchReviews = async () => {
        const { data, error } = await supabase
            .from('reviews')
            .select('*')
            .order('created_at', { ascending: false });

        if (error) {
            console.log('FETCH ERROR:', error);
            return;
        }

        setReviews(data || []);
    };

    const submitReview = async () => {
        if (!text.trim() || rating === 0) return;

        setLoading(true);

        const { data, error } = await supabase
            .from('reviews')
            .insert([
                {
                    text,
                    rating
                }
            ])
            .select();

        if (error) {
            console.log('INSERT ERROR:', error);
            setLoading(false);
            return;
        }
        if (data) {
            setReviews(prev => [data[0], ...prev]);
        }

        setText('');
        setRating(0);
        setLoading(false);
    };

    return (
        <section>
            <div className="hcontainer designerspage">

                <div className="rateScroll">

                    <div className="homee ratebg">

                        <div className="backBtn" onClick={() => navigate(-1)}>
                            ← Back
                        </div>

                        <h6 className="ratetitle">Rate Your Experience</h6>

                        <div className="ratelogo"></div>

                        <div className="howwasurexperince">
                            <h6 className="hwuetext">How was your experience?</h6>

                            <div className="starsdiv">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                        key={star}
                                        className={`star ${star <= rating ? 'active' : ''}`}
                                        onClick={() => setRating(star)}
                                    >
                                        ★
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="commentdiv">

                            <div className="thoughtsdiv">
                                <h3 className="sharetext">Share your thoughts</h3>

                                <textarea
                                    value={text}
                                    onChange={(e) => setText(e.target.value)}
                                    placeholder="Write your review..."
                                    className="textarea"
                                />

                                <button
                                    className="submitbtn"
                                    onClick={submitReview}
                                    disabled={loading}
                                >
                                    {loading ? 'Posting...' : 'Submit'}
                                </button>
                            </div>

                            <div className="recentreviewsdiv">
                                <h3 className="sharetext">Recent Reviews</h3>

                                {reviews.length === 0 && (
                                    <p className='nry'>
                                        No reviews yet
                                    </p>
                                )}

                                {reviews.map((r) => (
                                    <div className="reviewcard" key={r.id}>
                                        <div className="reviewstars">
                                            {'★'.repeat(r.rating)}
                                        </div>
                                        <p>{r.text}</p>
                                    </div>
                                ))}
                            </div>

                        </div>

                    </div>
                </div>
                <Nav />
            </div>
        </section>
    );
};

export default Rate;